import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

interface ErrorBoundaryProps extends WithTranslation {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundaryClass extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const { t } = this.props;
      return (
        <section className="space-ptb">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <div className="alert alert-danger d-flex align-items-center justify-content-center flex-wrap" role="alert">
                  <span>{t('errorBoundary.message')}</span>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger mt-2 mt-sm-0 ml-3"
                    onClick={this.handleRetry}
                  >
                    {t('common.retry')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}

const ErrorBoundary = withTranslation()(ErrorBoundaryClass);
export default ErrorBoundary;
